/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Editor_RolesInputs */

const en_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor roles`)
};

const ar_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدوار المحرر`)
};

const bn_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এডিটর রোল`)
};

const de_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor-Rollen`)
};

const es_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones del editor`)
};

const fr_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rôles d'éditeur`)
};

const pt_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funções de editor`)
};

const zh_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑角色`)
};

const tr_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenleyici rolleri`)
};

const ru_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роли редактора`)
};

const pl_svchip_editor_roles = /** @type {(inputs: Svchip_Editor_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role redaktora`)
};

/**
* | output |
* | --- |
* | "Editor roles" |
*
* @param {Svchip_Editor_RolesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_editor_roles = /** @type {((inputs?: Svchip_Editor_RolesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Editor_RolesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_editor_roles(inputs)
	if (locale === "bn") return bn_svchip_editor_roles(inputs)
	if (locale === "de") return de_svchip_editor_roles(inputs)
	if (locale === "es") return es_svchip_editor_roles(inputs)
	if (locale === "fr") return fr_svchip_editor_roles(inputs)
	if (locale === "pt") return pt_svchip_editor_roles(inputs)
	if (locale === "zh") return zh_svchip_editor_roles(inputs)
	if (locale === "tr") return tr_svchip_editor_roles(inputs)
	if (locale === "ru") return ru_svchip_editor_roles(inputs)
	if (locale === "pl") return pl_svchip_editor_roles(inputs)
	return en_svchip_editor_roles(inputs)
});